import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../query-keys';
import { Profile } from '../../../services/user-api';
import { useUserApi } from '../user-api/use-user-api';

export const useGetUserProfiles = () => {
  const userApi = useUserApi();
  return useQuery<Profile>({
    queryKey: QUERY_KEYS.learning.userProfiles(),
    staleTime: 0,
    queryFn: () => userApi.profile.getUserProfile(),
  });
};
